import ColorPaletteToolDark from '../../common/Color/ColorPaletteToolDark';

export default ColorPaletteToolDark;
